const extractNigerDigits = (value = "") => {
  const digits = String(value).replace(/\D/g, "");
  if (digits.startsWith("00227")) {
    return digits.slice(5, 13);
  }
  if (digits.startsWith("227")) {
    return digits.slice(3, 11);
  }
  return digits.slice(0, 8);
};

export const formatNigerPhone = (value = "") => {
  const digits = extractNigerDigits(value);
  if (!digits) return "";

  const parts = [];
  for (let i = 0; i < digits.length; i += 2) {
    parts.push(digits.slice(i, i + 2));
  }
  return `+227 ${parts.join(" ")}`;
};

export const normalizeNigerPhone = (value = "") => formatNigerPhone(value);

